import { render, staticRenderFns } from "./products-tab.vue?vue&type=template&id=38831d5e&"
import script from "./products-tab.vue?vue&type=script&lang=tsx&"
export * from "./products-tab.vue?vue&type=script&lang=tsx&"
import style0 from "./products-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports